export const matchType = (value, matcher, option) => {
    const result = matcher[value];
    if (!result && typeof option?.default !== "undefined") {
        return option?.default;
    }
    if (!result && option?.strict) {
        throw new Error(`unknown value type: ${value}`);
    }
    return matcher[value];
};
//# sourceMappingURL=type-matcher.js.map